function registerAutocomplete(div, callback) {
    if ($(div).hasClass('autocompleteaddressdivdone')) return;
    $(div).addClass('autocompleteaddressdivdone');

    var autocompletemap = new google.maps.places.Autocomplete(div, { types: ['geocode'] });
    autocompletemap.addListener('place_changed', async function () {
        var place = autocompletemap.getPlace();
        // console.log('google said', place);


        var streetnumber = place.address_components.filter(x => x.types[0] == 'street_number');
        var route = place.address_components.filter(x => x.types[0] == 'route');
        var locality = place.address_components.filter(x => x.types[0] == 'locality');
        var postal_town = place.address_components.filter(x => x.types[0] == 'postal_town');
        var administrative_area_level_1 = place.address_components.filter(x => x.types[0] == 'administrative_area_level_1');
        var country = place.address_components.filter(x => x.types[0] == 'country');
        var postal_code = place.address_components.filter(x => x.types[0] == 'postal_code');

        var streetnumber = (streetnumber.length ? streetnumber[0].long_name : null)
        var route = (route.length ? route[0].long_name : null);

        var address = ((streetnumber || '') + ' ' + (route || '')).trim();
        var data = {
            address: address == '' ? null : address,
            cp: postal_code.length ? postal_code[0].long_name : null,
            city: locality[0]?.long_name||postal_town[0]?.long_name,
            region: administrative_area_level_1.length ? administrative_area_level_1[0].long_name : null,
            country: country.length ? country[0].long_name : null,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
        };

        if (data.lat && data.lng) return callback(data);
        else console.log('incomplete geocoding', data);
    });
}

function initAutocompleteaddress() {
    $('#autocomplete-input').each(function () {
        registerAutocomplete(this, function (data) {
            var s = [];
            $('.categories input:checked').each(function () {
                s.push($(this).attr('name') + '=1')
            });
            if (parseInt($('.range-output').html())) s.push('distance=' + parseInt($('.range-output').html()));
            s.push('lat=' + data.lat);
            s.push('lng=' + data.lng);
            s.push('address=' + ((data.address || '') + ' ' + (data.cp || '') + ' ' + (data.city || '')).trim());

            // umami.trackEvent('home_locataire_searchAddressInput', 'click');
            window.location.href = '/fr/search?' + s.join('&');
        })
    })

    $('.autocompleteaddressdiv').each(function () {

        var self = this;
        if (!$(this).is(':visible')) return;
        if ($(self).find('.autocompleteaddress').length) return;

        var label = $(self).find('.control-label').eq(0).html()
        var input = $('<input type="text" class="autocompleteaddress" autocomplete="false" />');
        input.prop('required', $(this).find('.address').prop('required'));
        input.val($(this).find('.address').val() + ' ' + $(this).find('.cp').val() + ' ' + $(this).find('.city').val() + ' ' + $(this).find('.country').val());
        $(this).prepend('<p class="messagealert" style="display:none"></p>');
        var shit = $(`
            <div class="" for="address">
                <label class="control-label">
                    ${label}
                </label>
                <div>

                </div>
            </div>
        `);
        shit.find('label').next().append(input);
        $(this).prepend(shit);

        $(this).find('.address').closest('[for]').hide();
        $(this).find('.cp').closest('[for]').hide();
        $(this).find('.city').closest('[for]').hide();
        $(this).find('.country').closest('[for]').hide();
        $(this).find('.lat').closest('[for]').hide();
        $(this).find('.lng').closest('[for]').hide();
        $(this).find('.inseeCode').closest('[for]').hide();

        registerAutocomplete($(self).find('.autocompleteaddress')[0], function (data) {
            if (!data.address || !data.cp) return;

            (async (url) => {
                try {
                    if ($(self).find('.inseeCode').length) {
                        const response = await fetch(url);
                        if (response.ok) {
                            const result = await response.json();
                            if (result.inseeCode) data.inseeCode = result.inseeCode;
                        }
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    $(self).find('.lat').val(data.lat || '');
                    $(self).find('.lng').val(data.lng || '');
                    $(self).find('.address').val(data.address || '');
                    $(self).find('.cp').val(data.cp || '');
                    $(self).find('.city').val(data.city || '');
                    $(self).find('.country').val(data.country || '');
                    $(self).find('.inseeCode').val(data.inseeCode || '');

                    createMap(data.lat, data.lng);
                    autocompleteHideError(self);
                }
            })(`https://flatbayflo.tech.flatbay.fr/fr/property/inseeCode?cp=${data.cp}&city=${data.city}`);
        });
    });
}


function createMap(lat, lng) {
    if ($('#map').length == 0) return;
    console.log('create Map', lat, lng);

    var gps = { lat: lat, lng: lng };
    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 15,
        center: gps
    });
    var marker = new google.maps.Marker({
        position: gps,
        map: map
    });
    $('#map').height(490);
}

$(document).on('click', '.autocompletemanuel', function () {
    $(this).closest('.autocompleteaddressdiv').find('.autocompleteaddress').closest('[for]').hide();
    $(this).closest('.autocompleteaddressdiv').find('.messagealert').hide();
    $(this).closest('.autocompleteaddressdiv').find('.address').closest('[for]').show();
    $(this).closest('.autocompleteaddressdiv').find('.cp').closest('[for]').show();
    $(this).closest('.autocompleteaddressdiv').find('.city').closest('[for]').show();
    $(this).closest('.autocompleteaddressdiv').find('.country').closest('[for]').show();
    $(this).closest('.autocompleteaddressdiv').find('.inseeCode').closest('[for]').show();
    // $(this).closest('.autocompleteaddressdiv').find('.lat').closest('[for]').show();
    // $(this).closest('.autocompleteaddressdiv').find('.lng').closest('[for]').show();
});

$(document).on('change', '.autocompleteaddress', function () {
    if ($(this).val() == '') return autocompleteHideError($(this).closest('.autocompleteaddressdiv'));

    autocompleteShowError($(this).closest('.autocompleteaddressdiv'));
})

function autocompleteShowError(div) {
    $(div).find('.autocompleteaddress').addClass('error');
    $(div).find('.messagealert').show();
    $(div).find('.messagealert').html('Veuillez sélectionner une adresse reconnue par Google (Précisez le n° et la rue)');
    //  <b class="autocompletemanuel" style="cursor: pointer">Ou cliquez ici pour la saisir manuellement</b>
    $(div).find('.messagealert').css({
        color: 'red',
    });
    $('button,.btn-enregistrer,.validate').hide();
}
function autocompleteHideError(div) {
    $(div).find('.autocompleteaddress').removeClass('error');
    $(div).find('.messagealert').hide();
    $('button,.btn-enregistrer,.validate').show();
}